import publicRules from './rules'
import * as axios from "@/store/http";

// 全局公共方法
export default {
    install(Vue) {
        //切换系统语言方法
        Vue.prototype.changeLanguage = function(strType) {
            if (strType.toString().length <= 0) {
                return
            }
            document.body.classList.remove(`lang-${strType}`)
            document.body.classList.add(`lang-${strType}`)
            document.body.setAttribute('lang', strType)
            window.localStorage.setItem('localeLanguage', strType);
            
            this.$i18n.locale = strType
        };

        // 获取缓存中的系统语言类型  return String
        Vue.prototype.getLanguageType = function() {
            return window.localStorage.getItem('localeLanguage')
        }

        // 获取缓存中的系统语言类型  return String
        Vue.prototype.initTheme = function() {
                let strTheme = window.localStorage.getItem('dataTheme')
                if (strTheme) {
                    window.document.documentElement.setAttribute('data-theme', strTheme)
                } else {
                    window.document.documentElement.setAttribute('data-theme', 'default-theme')
                    window.document.documentElement.setAttribute('data-theme', 'default-theme')
                }
            },
            // 默认灰色提示
            Vue.prototype.tipDefault = function(strMessage) {
                this.$message({
                    showClose: false,
                    message: strMessage
                });
            },
            // 成功提示
            Vue.prototype.tipSuccess = function(strMessage) {
                this.$message({
                    showClose: false,
                    message: strMessage,
                    type: 'success'
                });
            },
            // 警告提示
            Vue.prototype.tipWarn = function(strMessage) {
                this.$message({
                    showClose: false,
                    message: strMessage,
                    type: 'warning'
                });
            },

            // 错误提示
            Vue.prototype.tipError = function(strMessage) {
                this.$message({
                    showClose: false,
                    dangerouslyUseHTMLString: true,
                    message: strMessage,
                    type: 'error'
                });
            }

        // 右侧滑出类提示 @title标题  @strMessage内容  @type提示类型——success、default、error、warn
        Vue.prototype.tipRight = function(title, strMessage, type) {
            if (type === 'success') {
                this.$notify({
                    title: title,
                    message: strMessage,
                    type: 'success'
                });
            } else if (type === "error") {
                this.$notify.error({
                    title: title,
                    message: strMessage
                });
            } else if (type === "warn") {
                this.$notify({
                    title: title,
                    message: strMessage,
                    type: 'warning'
                });
            } else if (type === "default") {
                this.$notify.info({
                    title: title,
                    message: strMessage
                });
            }
		}

        /**
		 * 自定义的对话框 --- yuyongchun
         * type 对话框类型
         * title 如果为 Default 类型，strMessage 参数传空，提示信息传入 title 参数
		 * strMessage 提示信息
		 * customBtnObj 如果是 Error 类型，可能需要传入 customBtnObj（自定义按钮）
         * */
        Vue.prototype.tipCustomConfirm = function(type, title, strMessage, customBtnObj) {
			return new Promise((resolve, reject) => {
				const h = this.$createElement;
				if(type === "success") {
					this.$msgbox({
						message: h('div', null, [
							h('div', { class: 'title' }, title),
							h('div', { class: 'info' }, strMessage)
						]),
						type: "success",
						customClass: 'success-box',
						iconClass: "iconfont pto-cir-check-circle",
						showCancelButton: true,
						confirmButtonText: this.$t('common.confirm'),
						confirmButtonClass: 'confirm-btn el-button--success',
						cancelButtonText: this.$t('common.cancel'),
						}).then(() => {
							resolve(true);
						}).catch(() => {
							reject(false);
						});
				} else if(type === "error") {
					this.$msgbox({
						message: h('div', null, [
							h('div', { class: 'title' }, title),
							h('div', { class: 'info' }, strMessage),
							h('div', { class: 'customBtnsWrap'}, [
								h('span', {
									class: 'btnItem',
									on: {
										click: this[customBtnObj.clickEventName]
									}
								}, customBtnObj.name)
							])
						]),
						type: "error",
						customClass: 'error-box',
						iconClass: "iconfont pto-cir-close-circle",
						showCancelButton: true,
						confirmButtonText: this.$t('common.confirm'),
						confirmButtonClass: 'confirm-btn el-button--danger',
						cancelButtonText: this.$t('common.cancel'),
						}).then(() => {
							resolve(true);
						}).catch(() => {
							reject(false);
						});
				} else if(type === "warn") {
					this.$msgbox({
						message: h('div', null, [
							h('div', { class: 'title' }, title),
							h('div', { class: 'info' }, strMessage)
						]),
						type: "warning",
						customClass: 'warning-box',
						iconClass: "iconfont pto-cir-question-circle",
						showCancelButton: true,
						confirmButtonText: this.$t('common.confirm'),
						confirmButtonClass: 'confirm-btn el-button--warning',
						cancelButtonText: this.$t('common.cancel'),
						}).then(() => {
							resolve(true);
						}).catch(() => {
							reject(false);
						});
				} else if(type === "default") {
					// 默认对话框

					this.$msgbox({
						message: h('div', null, [
							h('div', { class: 'title' }, title)
						]),
						type: "info",
						customClass: 'info-box',
						iconClass: "iconfont pto-cir-info-circle",
						showCancelButton: true,
						confirmButtonText: this.$t('common.confirm'),
						confirmButtonClass: 'confirm-btn',
						cancelButtonText: this.$t('common.cancel'),
						}).then(() => {
							resolve(true);
						}).catch(() => {
							reject(false);
						});
				}
			});
        }

        /**
         * 自定义的对话框 --- yuyongchun
         * type 对话框类型
         * title 如果为 Default 类型，strMessage 参数传空，提示信息传入 title 参数
         * strMessage 提示信息
         * customBtnObj 如果是 Error 类型，可能需要传入 customBtnObj（自定义按钮）
         * 可带返回值
         * */
        Vue.prototype.tipCustomConfirmNew = function (type, title, strMessage, customBtnObj) {
          return new Promise((resolve, reject) => {
            const h = this.$createElement;
            if (type === "success") {
              this.$msgbox({
                message: h('div', null, [
                  h('div', {
                    class: 'title'
                  }, title),
                  h('div', {
                    class: 'info'
                  }, strMessage)
                ]),
                type: "success",
                customClass: 'success-box',
                iconClass: "iconfont pto-cir-check-circle",
                showCancelButton: true,
                confirmButtonText: this.$t('common.confirm'),
                confirmButtonClass: 'confirm-btn el-button--success',
                cancelButtonText: this.$t('common.cancel'),
              }).then(() => {
                resolve(true);
              }).catch(() => {
                resolve(false);
              });
            } else if (type === "error") {
              this.$msgbox({
                message: h('div', null, [
                  h('div', {
                    class: 'title'
                  }, title),
                  h('div', {
                    class: 'info'
                  }, strMessage),
                  h('div', {
                    class: 'customBtnsWrap'
                  }, [
                    h('span', {
                      class: 'btnItem',
                      on: {
                        click: this[customBtnObj.clickEventName]
                      }
                    }, customBtnObj.name)
                  ])
                ]),
                type: "error",
                customClass: 'error-box',
                iconClass: "iconfont pto-cir-close-circle",
                showCancelButton: true,
                confirmButtonText: this.$t('common.confirm'),
                confirmButtonClass: 'confirm-btn el-button--danger',
                cancelButtonText: this.$t('common.cancel'),
              }).then(() => {
                resolve(true);
              }).catch(() => {
                resolve(false);
              });
            } else if (type === "warn") {
              this.$msgbox({
                message: h('div', null, [
                  h('div', {
                    class: 'title'
                  }, title),
                  h('div', {
                    class: 'info'
                  }, strMessage)
                ]),
                type: "warning",
                customClass: 'warning-box',
                iconClass: "iconfont pto-cir-question-circle",
                showCancelButton: true,
                confirmButtonText: this.$t('common.confirm'),
                confirmButtonClass: 'confirm-btn el-button--warning',
                cancelButtonText: this.$t('common.cancel'),
              }).then(() => {
                resolve(true);
              }).catch(() => {
                resolve(false);
              });
            } else if (type === "default") {
              // 默认对话框

              this.$msgbox({
                message: h('div', null, [
                  h('div', {
                    class: 'title'
                  }, title)
                ]),
                type: "info",
                customClass: 'info-box',
                iconClass: "iconfont pto-cir-info-circle",
                showCancelButton: true,
                confirmButtonText: this.$t('common.confirm'),
                confirmButtonClass: 'confirm-btn',
                cancelButtonText: this.$t('common.cancel'),
              }).then(() => {
                resolve(true);
              }).catch(() => {
                resolve(false);
              });
            }
          });
        }

        // 弹窗提示
        Vue.prototype.tipAlert = function(title, strMessage, btnTitle) {
                this.$alert(strMessage, title, {
                    confirmButtonText: btnTitle,
                    callback: action => {
                        // 回调函数
                    }
                });
            }
            // confirm弹窗提示 @strFuncName是点击确定调用的函数名的字符串 如：'alert'
        Vue.prototype.tipConfirm = function(title, strMessage, btnTitle, strFuncName) {
                this.$confirm(strMessage, title, {
                        confirmButtonText: btnTitle,
                        distinguishCancelAndClose: true,
                        cancelButtonText: '取消'
                    })
                    .then(() => {
                        // 这里面是点击确定按钮的事件
                        eval(strFuncName + '()')
                    })
                    .catch(action => {
                        // 这里面是点击取消按钮的事件
                        this.$message({
                            type: 'info',
                            message: '已取消操作'
                        });
                    });
            }
            // 设置必填 el-table-column需要有column-key属性
        Vue.prototype.must = function({ column }, rulesRequired) {
            if (rulesRequired !== undefined && rulesRequired !== '' && rulesRequired !== null) {
                if (rulesRequired.indexOf(';' + column.columnKey + '|') !== -1) {
                    return 'must'
                }
            }
        }

        Vue.prototype.myMust = function(rule, rulesRequired) {
            if (rulesRequired !== undefined && rulesRequired !== '' && rulesRequired !== null) {
                if (rulesRequired.indexOf(';' + rule + '|') !== -1) {
                    return 'must'
                }
            }
        }

        // 行项列表新增
        Vue.prototype.addrow = function (rowsList, model, addIndex) {
            let addrow = {};
            if (model) {
                addrow = Object.assign(addrow, model);
            }

            if(addIndex == undefined){
                rowsList.push(addrow);
            }else{
                // 指定元素的插入位置
                rowsList.splice(addIndex, 0, addrow);
            }
        }

        // 行项列表删除
        Vue.prototype.delrow = function(index, row, rowsList, rowkey, deleteID) {
            rowsList.splice(index, 1);
            if (row[rowkey] !== undefined && row[rowkey] !== null && row[rowkey] !== '') {
                deleteID.push(row[rowkey]);
            }
        }
        // 行项列表删除
        Vue.prototype.delrowbyone = function(index, row, rowsList, rowkey, deleteID) {
            if(rowsList.length == 1){
                this.tipDefault("Please fill in at least one line of educational information!");
            }else{
                rowsList.splice(index, 1);
                if (row[rowkey] !== undefined && row[rowkey] !== null && row[rowkey] !== '') {
                    deleteID.push(row[rowkey]);
                }
             }
        }
        // 行项列表删除，若为空列表默认新增一个空行
        Vue.prototype.delrowExt = function (index, row, rowsList, rowkey, deleteID, model) {
            this.delrow(index, row, rowsList, rowkey, deleteID);

            if (rowsList.length == 0) {
                this.addrow(rowsList, model);
            }
        }

        // 行项列表行复制
        Vue.prototype.copyrow = function(index, row, rowsList, rowkey) {
            let copyrow = {};
            if(row){
                copyrow = Object.assign(copyrow, row);
                copyrow[rowkey] = null;
            }
            this.addrow(rowsList, copyrow);
        }

        // 动态获取验证规则
        Vue.prototype.getRules = function(rulesData, formTipArray) {

            var arr_pattern1 = [];

            //必填域格式：;FIELD|MSG;FIELD|MSG;
            arr_pattern1 = rulesData.split(";");

            var thisRules = {} //规则集合
            for (var i = 0; i < arr_pattern1.length; i++) {
                var v_pattern = arr_pattern1[i];
                //规则为空的情况不做校验
                if (v_pattern == "") {
                    continue;
                }

                //拆分字段和消息：FIELD|MSG
                var rulesvalue = v_pattern.split("|");
                let field = rulesvalue[0].toLowerCase(); //规则数组名
                var tipmsg = this.$t('flow_process.notnulltip');
                let message = rulesvalue[1] + "," + tipmsg; //传递信息
                let validRules = "validateRequired"; //自定义规则,这里必须用let,变量是新增的
                let rules = [{ required: true, validator: (rule, value, callback) => publicRules.FormValidate.Form()[validRules](rule, value, callback, message, formTipArray), trigger: 'XXX' }];
                thisRules[field] = rules;
            }
            return thisRules
        }

        // 表单验证提示框
        Vue.prototype.formErrorTip = function(title, ArrMsg) {
                let strHtmlMsg = ''
                for (var i = 0; i < ArrMsg.length; i++) {
                    strHtmlMsg += "<p id='ID_error_msg'>" + ArrMsg[i] + "</p>"
                }
                let oFormValidateTip = this.$notify.error({
                    title: title,
                    dangerouslyUseHTMLString: true,
                    message: strHtmlMsg,
                    duration: 0
                });
                this.$set(oFormValidateTip, "verticalOffset", 101);
                return oFormValidateTip;
            }
            // 表单验证提示框
        Vue.prototype.formErrorTip2 = function(title, ArrMsg) {
            let strHtmlMsg = ''
            for (var i = 0; i < ArrMsg.length; i++) {
                strHtmlMsg += "<p id='ID_error_msg'>" + ArrMsg[i] + "</p>"
            }
            let oFormValidateTip = this.$notify.error({
                title: title,
                dangerouslyUseHTMLString: true,
                message: strHtmlMsg,
                duration: 10000
            });
            this.$set(oFormValidateTip, "verticalOffset", 101);
            return oFormValidateTip;
        }
        //格式化飙到时间
        Vue.prototype.forMatDate = function(datestr)
        {
                //let myDate = new Date(datestr);
                console.log("datestr"+datestr);
                let d = datestr.slice(0,2);
                let m = datestr.slice(3,5);
                let y = datestr.slice(6);

                console.log("y"+y+" m"+m+" d"+d);
                let newdate=(y+ "-" + m + "-" + d);
              return newdate;
        }
        //用于测试内嵌弹出框1——选择库区，方法名对应sys_cselectpub_field的SELECTFUN字段
        Vue.prototype.selectStoreregion = function() {
                let embedData = {
                    "selectwintype": "select-list-info",
                    "selecttype": "checkbox",
                    "defparas": this.$store.state.areacode,
                    "cond": "undefined",
                    "componenttype": "select-list-info"//控制内嵌组件的类型
                };
                return embedData;
            }
            //用于测试内嵌弹出框2——选择树
        Vue.prototype.selectTreeInfo = function() {
            let embedData = {
                "selectwintype": "select-tree-tag-info",
                "selecttype": "checkbox",
                "defparas": "",
                "cond": "undefined",
                "componenttype": "select-tree-tag-info",//控制内嵌组件的类型
                "scon": "86852"
            };
            return embedData;
        }

        //用于NTKO组件弹窗的显示
        Vue.prototype.ntkoOpen = function() {
            // 定义ntkoBrowser
            let ntkoBrowser = require('@/js/ntkobackground.min.js').ntkoBrowser
            let ntkoed = ntkoBrowser.ExtensionInstalled();
            // 打开控件 这块在路由中配置对应的组件，如果部署tomcat，需要在Context中指定该路由的项目是该vue项目
            //alert(window.location.origin);
            if (!ntkoed) {
                ntkoBrowser.openWindow(window.location.origin + "/ntko")
            } else {
                window.open("http://localhost:8080/ntko")
            }

            // 注册回调方法
            window.ntkoCloseEvent = function() {
                alert("跨浏览器插件应用程序窗口已关闭!");
            }
        }

        //初始化下拉框 that为调用对象的;paramArrays为多个下拉框的查询参数
        Vue.prototype.initDropDown = async function(that, paramArrays) {
            let urlArray = "selectController/getSelectOption";
            await axios.post(urlArray, paramArrays).then(({ data }) => {
                if (data.code == "1") {
                    for (let i = 0; i < data.data.length; i++) {
                        that[data.data[i].showcode] = data.data[i].options; //将下拉数据赋值给对应变量
                    }
                } else {
                    let message = data.msg;
                    console.log('2019年11月18日20:24:09 common.js[初始化下拉框失败]——[message] :', message);
                }
                return data;
            }).catch((error) => {
                console.log('2019年11月18日20:24:09 common.js[初始化下拉框失败]——[error] :', error);
            });
        }

        //初始化下拉框 that为调用对象的;paramArrays为多个下拉框的查询参数,自定义后端接口
        Vue.prototype.initDropDownWithUrl = async function(that, paramArrays,url) {
          let urlArray = url;
          await axios.post(urlArray, paramArrays).then(({ data }) => {
              if (data.code == "1") {
                  for (let i = 0; i < data.data.length; i++) {
                      that[data.data[i].showcode] = data.data[i].options; //将下拉数据赋值给对应变量
                  }
              } else {
                  let message = data.msg;
                  console.log('2019年11月18日20:24:09 common.js[初始化下拉框失败]——[message] :', message);
              }
              return data;
          }).catch((error) => {
              console.log('2019年11月18日20:24:09 common.js[初始化下拉框失败]——[error] :', error);
          });
      }

        //初始化下拉框 that为调用对象的;field为this对象的一个对象showcode为对象里面的属性;paramArrays为多个下拉框的查询参数
        Vue.prototype.initFieldDropDown = async function(that,field, paramArrays) {
            let urlArray = "selectController/getSelectOption";
            await axios.post(urlArray, paramArrays).then(({ data }) => {
                if (data.code == "1") {
                    for (let i = 0; i < data.data.length; i++) {
                        that.$set(that[field],data.data[i].showcode,data.data[i].options)
                        // that[data.data[i].showcode] = data.data[i].options; //将下拉数据赋值给对应变量
                    }
                } else {
                    let message = data.msg;
                    console.log('2019年11月18日20:24:09 common.js[初始化下拉框失败]——[message] :', message);
                }
                return data;
            }).catch((error) => {
                console.log('2019年11月18日20:24:09 common.js[初始化下拉框失败]——[error] :', error);
            });
        }

        //彈出新窗口
        Vue.prototype.openWin = function(url, query) {
            let portalflag = this.$route.query.portalflag;
            let sysflag = this.$route.query.sysflag;
            if(portalflag == 'portal'){
                if(url.indexOf("?") > -1){
                    url = url + "&portalflag="+portalflag;
                }else{
                    url = url + "?portalflag="+portalflag;
                }
            }
            if(sysflag == 'ft'){
                if(url.indexOf("?") > -1){
                    url = url + "&sysflag="+sysflag;
                }else{
                    url = url + "?sysflag="+sysflag;
                }
            }
            let routeUrl = this.$router.resolve({
                path: url,
                query: query
            });
            let h = window.screen.availHeight;
            let w = window.screen.availWidth;
            // let pos =
            //     "width=" +
            //     w +
            //     ",height=" +
            //     h +
            //     ",left=" +
            //     (window.screen.width - w) +
            //     ",top=" +
            //     (window.screen.height - h) ;
            
            let pos =
                "width=" +
                (w-20) +
                ",height=" +
                (h-100) +
                ",top=0,left=0,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no";

            // let pos =
            // "fullscreen,resizable=yes,toolbar=no";     
            window.open(routeUrl.href, "_blank");
        }

        //彈出新窗口（页面窗口小点）
        Vue.prototype.openWinSmaller = function(url, query) {
            let portalflag = this.$route.query.portalflag;
            let sysflag = this.$route.query.sysflag;
            if(portalflag == 'portal'){
                if(url.indexOf("?") > -1){
                    url = url + "&portalflag="+portalflag;
                }else{
                    url = url + "?portalflag="+portalflag;
                }
            }
            if(sysflag == 'ft'){
                if(url.indexOf("?") > -1){
                    url = url + "&sysflag="+sysflag;
                }else{
                    url = url + "?sysflag="+sysflag;
                }
            }
            let routeUrl = this.$router.resolve({
                path: url,
                query: query
            });
            let h = window.screen.height ;
            let w = window.screen.width;
            let pos =
                "width=" +
                w +
                ",height=" +
                h +
                ",left=" +
                (window.screen.width-w)/2 +
                ",top=" +
                (window.screen.height-h)/3 ;
            window.open(routeUrl.href, "_blank", pos);
        }

        //彈出新窗口 (根据系统名)
        Vue.prototype.openSysWin = function(url, sysid) {
            var sys_pre = "";
            if (sysid == "CONTRACT"){
                sys_pre = process.env.SYS_PRE_CONTRACT;
            } else if (sysid == "HR"){
                sys_pre = process.env.SYS_PRE_HR;
            } else if (sysid == "SCM"){
                sys_pre = process.env.SYS_PRE_SCM;
            } else if (sysid == "PROJECT"){
                sys_pre = process.env.SYS_PRE_PROJECT;
            }
            let vurl = window.location.origin + sys_pre +url
            let h = window.screen.availHeight;
            let w = window.screen.availWidth;
            let pos =
                "width=" +
                (w-20) +
                ",height=" +
                (h-100) +
                ",top=0,left=0,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no";
            window.open(vurl, "_blank", pos);
        }

        /**
         * 去除行项的空行
         * record:存储行项信息的对象
         * listName:行项信息名
         */
        Vue.prototype.delNullLine = function(record,listName){
          let newList=[];
          for(let i=0;i<record[listName].length;i++){
            //如果数组的对象不为空，将其放入新建的对象
            if(Object.keys(record[listName][i]).length != 0){
              newList.push(record[listName][i]);
            }
          }
          //将新对象数组赋值给旧对象
          record[listName]=[...newList];
        }

        /**
         * 去除行项的空行
         * record:存储行项信息的对象
         * listName:行项信息名
         * existColumn:用于判定空的列名
         */
        Vue.prototype.delNullLineByColumn= function(record,listName,existColumn){
          let newList=[];
          for(let i=0;i<record[listName].length;i++){
            //如果数组的对象不为空，将其放入新建的对象
            if(record[listName][i][existColumn]!=''&&record[listName][i][existColumn]!=null&&record[listName][i][existColumn]!=undefined){
              newList.push(record[listName][i]);
            }
          }
          //将新对象数组赋值给旧对象
          record[listName]=[...newList];
        }

        /**
         * 对象不为空判断
         * obj 对象
         * false：为空 true：不为空
         */
        Vue.prototype.isNotNullOrEmpty= function (obj){
          return (undefined==obj || (obj+"")=="" || obj==null ) ? false : true ;
        }

        // 获取指定父组件名称的实例
        Vue.prototype.getParentInstance = function (componentName) {
            let parent = this.$parent || this.$root;
            let name = parent.$options.name;

            while (parent && (!name || name !== componentName)) {
                parent = parent.$parent;
                if (parent) {
                    name = parent.$options.name;
                }
            }

            return parent;
        }

        //增加行项时，在指定父组件页面内自动往上滚动
        Vue.prototype.autoScrollByParent = function (componentName) {
            let parentComponent = this.getParentInstance(componentName);
            if (parentComponent) {
                let $mainObj = parentComponent.$refs.mainContent,
                    preScrollTop = $mainObj.scrollTop; // 上一次 mainContent 向上滚动的高度

                this.$nextTick(function () {
                    let $layoutObj = this.$root.$children[0].$children[0],
                        preScrollHeight = $layoutObj.mainContentObj_scrollH, // 上一次 mainContent 内容高度
                        curScrollHeight = $mainObj.scrollHeight; // 当前 mainContent 内容高度

                    let differVlaue = curScrollHeight - preScrollHeight;

                    $mainObj.scrollTop = preScrollTop + differVlaue;

                    $layoutObj.mainContentObj_scrollH = $mainObj.scrollHeight;
                })
            }
        }

        /*
         * 保证输入框输入的为数字
         * precision：总位数（不含小数点），为空或0时不限位数
         * scale：小数位数，为空或0时表示要求输入整数
         * issymbol: 是否要 去掉 -符号 值为true表示去掉，其他不去掉  用来判断是否只允许输入正数
         */
        Vue.prototype.validateNum = function (dataObj, dataAttrName, eventObj, precision, scale, issymbol) {
            if (undefined == issymbol) {
                issymbol = false;
            }
            var oValue = eventObj.target.value;
            if (oValue.charAt(0) == "-") {
                oValue = oValue.substring(1, oValue.length);
            }
            if (scale == null || scale == 0) {
                // 要求输入为整数
                oValue = oValue.replace(/[^\d]/g, "");
                if (precision != null && precision > 0) {
                    // 限制整数位数
                    oValue = oValue.replace(
                        new RegExp("^(\\d{" + precision + "})\\d+", "g"),
                        "$1"
                    );
                }
            } else {
                oValue = oValue.replace("。", ".");
                oValue = oValue.replace(/[^\d.]/g, "");
                oValue = oValue.replace(/^\./g, "");
                oValue = oValue.replace(/\.{2,}/g, ".");
                oValue = oValue
                    .replace(".", "$#$")
                    .replace(/\./g, "")
                    .replace("$#$", ".");
                oValue = oValue.replace(
                    new RegExp("^(\\d{" + (precision - scale) + "})\\d+", "g"),
                    "$1"
                );
                oValue = oValue.replace(
                    new RegExp("(\\.\\d{" + scale + "})\\d+", "g"),
                    "$1"
                );
            }
            if (eventObj.target.value.charAt(0) == "-" && !issymbol) {
                oValue = "-" + oValue;
            }

            this.$set(dataObj, dataAttrName, oValue);
        }

         /*------ yuyongchun ------*/

        /**
     * 处理行项的展开状态
     * tableRef 表格的 ref 值，用来获取 table
     * tableKey 用于区别一个页面有多个 table
     * dataArry 表格绑定的数据（:data）
     * expandAllRow 每次是否展开所有的行，默认都展开
		 * operateType 触发类型，"add"或"del"
     * */
    Vue.prototype.toExpandRows = function(tableRef, tableKey, dataArry, expandAllRow, operateType) {
        this.$nextTick(function() {
          let $table = this.$refs[tableRef] || null;
          if(!$table) {
            return false;
          }
          let trs = $table.$refs.bodyWrapper.children[0].children[1].children;

          // 展开所有行
          dataArry &&
            dataArry.length > 0 &&
            dataArry.map(v => {
              $table.toggleRowExpansion(v, true);
            });

					if(expandAllRow || typeof expandAllRow === "undefined") {
						return false;
					}

          // 隐藏所有行
          this.$nextTick(function() {
            if (trs.length > 0) {
              let index = 0;
              for (let i = 0, len = trs.length; i < len; i++) {
                let tr = trs[i];
                if (tr.classList.contains("expanded")) {
                  // 为每行设置一个唯一标识，data-index
                  tr.setAttribute("key", index);
                  tr.setAttribute("data-index", index);
                  index < dataArry.length && index++;

                  tr.nextElementSibling.style.display = "none";
                }
              }
						}

						if(!expandAllRow && typeof expandAllRow !== "undefined" && operateType !== "del") {
							this["expandedRows_" + tableKey][this["expandedRows_" + tableKey].length] = dataArry.length-1;
						}

            // 展开原已展开的行
            for (let i = 0, len = trs.length; i < len; i++) {
              let tr = trs[i];
              let isExist = this["expandedRows_" + tableKey].some(function(v) {
                return parseInt(tr.getAttribute("data-index")) === v;
              });

              if (isExist) {
                let expandRow = tr.nextElementSibling;
                if (expandRow && expandRow.style.display === "none") {
                  expandRow.style.display = "table-row";
                } else {
                  // 根本不存在的话就删除
                  this["expandedRows_" + tableKey].splice(i, 1);
                }
              }
						}

          });
        });
      }

      /**
       * 删除行项调用这个方法
       * tableRef 表格的 ref 值，用来获取 table
       * tableKey 用于区别一个页面有多个 table
       * dataArry 表格绑定的数据（:data）
       * */
      Vue.prototype.delExpandRow = function(tableRef, tableKey, dataArry, scope) {
        this.$nextTick(function() {
          let newArr = this["expandedRows_" + tableKey].filter(function(v) {
            return v !== scope.$index;
          });

          newArr.length > 0 &&
            newArr.map((v, i, arr) => {
                if(v > scope.$index) {
                    arr[i] = v - 1;
                }
            });

          this["expandedRows_" + tableKey] = newArr;

          this.toExpandRows(tableRef, tableKey, dataArry, false, "del");
        });
			}

      // 设置 dialog 的位置
		Vue.prototype.setDialogPos = function(dialogRef) {
			let dialogDom = null;
			let _this = this;

			if(dialogRef) {
				dialogDom = _this.$refs[dialogRef].$refs.dialog;
			} else {
				findDialog();
			}

			function findDialog() {
				let childrens = _this.$children;
				for(let i=0,len=childrens.length; i<len; i++) {
					if(childrens[i].$refs.dialog) {
						dialogDom = childrens[i].$refs.dialog;
						break;
					}
				}
			}

			let bodyH = document.body.offsetHeight;
			let leftH = bodyH - dialogDom.clientHeight;
			let dialogMarginTop = "5px";

			if(leftH > 5) {
					dialogMarginTop = leftH / 2 + "px";
			}

            dialogDom.style.opacity = 1;
			dialogDom.style.marginTop = dialogMarginTop;
		}

        //增加行项时，页面自动往上滚动
        Vue.prototype.autoScroll = function() {
            let $mainObj = this.$refs.mainContent,
                preScrollTop = $mainObj.scrollTop; // 上一次 mainContent 向上滚动的高度

            this.$nextTick(function() {
                let $layoutObj = this.$root.$children[0].$children[0],
                    preScrollHeight = $layoutObj.mainContentObj_scrollH, // 上一次 mainContent 内容高度
                    curScrollHeight = $mainObj.scrollHeight; // 当前 mainContent 内容高度

                let differVlaue = curScrollHeight - preScrollHeight;

                $mainObj.scrollTop = preScrollTop + differVlaue;

                $layoutObj.mainContentObj_scrollH = $mainObj.scrollHeight;
            })
        }

        Vue.prototype.setMainContentHeight = function(mainContentObj) {
            if (typeof mainContentObj === "undefined" ||
                JSON.stringify(mainContentObj) === "{}" ||
                typeof mainContentObj !== "object") {
                return false;
            }
            let bodyHeight = document.body.clientHeight;
            let headerHeight = 40;
            let paddingSum = 50;
            let topOpterationHeight = 40;
            let lastHeight = bodyHeight - headerHeight - paddingSum;

            mainContentObj.style.height = lastHeight + "px";
        }

        // 设置列表页table高度（只适用列表页面结构）
        Vue.prototype.calcListTableHeight = function() {
            this.$nextTick(function() {

                let $targetPparent = this.$parent;
                function findParent(className) {
                    if($targetPparent.$el.classList.contains(className)) {
                        return false;
                    }
                    $targetPparent = $targetPparent.$parent;
                    findParent("el-main");
                }
                findParent("el-main");

                let totalHeight = $targetPparent ? $targetPparent.$el.offsetHeight : 0;
                let $searchForm = (() => {
                    let $searchForm = this.$refs.searchForm;
                    if($searchForm) {
                        return $searchForm.$el ? $searchForm.$el : $searchForm;
                    }
                })();
                let $listOperation = (() => {
                    let $listOperation = this.$refs.listOperation;
                    if($listOperation) {
                        return $listOperation.$el ? $listOperation.$el : $listOperation;
                    }
                })();
                const searchFormHeight = $searchForm ? $searchForm.offsetHeight : 0;
                const listOperationHeight = $listOperation ? $listOperation.offsetHeight : 0;

                // 首页 btnGroup 相关
                let btnGroupHeight = 0;
                let btnGroupSpacing = 0;
                if(this.$refs.btnGroup) {
                    btnGroupHeight = this.$refs.btnGroup.offsetHeight;
                    btnGroupSpacing = 10;
                }
                const btnGroupRelated = btnGroupHeight + btnGroupSpacing;

                // 确认边距
                const definiteSpacing = 134;

                // const paginationHeight = this.$refs.pagination.$el.offsetHeight;
                const calculatedHeight = totalHeight - searchFormHeight - listOperationHeight - definiteSpacing - btnGroupRelated;
                // const calculatedHeight = totalHeight - searchFormHeight - 80;
                // const tableThHeight = 27; // 表头行高
                // const tableTdHeight = 35; // 内容行高
                // const entireLines = Math.floor((calculatedHeight - tableThHeight) / tableTdHeight);
                // this.tableListHeight = entireLines * tableTdHeight + tableThHeight;
                this.tableListHeight = calculatedHeight;
            })
        }

        /**
         * "-"号转换成负
         * @param numStr
         * @returns {String}
         */
        Vue.prototype.changeArabia_to_Chinese = function(numStr) {
            var newStr="";
            if(numStr.indexOf("-")>-1){
                newStr="负";
                numStr=numStr.replace("-","");
            }
            newStr=newStr+this.Arabia_to_Chinese(numStr);
            return newStr;
        }

        //数字转中文
        Vue.prototype.Arabia_to_Chinese = function(Num) {
            var newchar = "";
            for(var i=Num.length-1;i>=0;i--)
            {
                Num = Num.replace(",","");//替换tomoney()中的“,”
                Num = Num.replace(" ","");//替换tomoney()中的空格
            }
            Num = Num.replace("￥","");//替换掉可能出现的￥字符
            if(isNaN(Num)) { //验证输入的字符是否为数字
                setBottomStatusInfo("请检查小写金额是否正确");
                return newchar;
            }
            //---字符处理完毕，开始转换，转换采用前后两部分分别转换---//
            var part = String(Num).split(".");
            //小数点前进行转化
            for(var i=part[0].length-1;i>=0;i--){
            if(part[0].length > 10){ setBottomStatusInfo("位数过大，无法计算");return "";}//若数量超过拾亿单位，提示
                tmpnewchar = "";
                perchar = part[0].charAt(i);
                switch(perchar){
                case "0": tmpnewchar="零" + tmpnewchar ;break;
                case "1": tmpnewchar="壹" + tmpnewchar ;break;
                case "2": tmpnewchar="贰" + tmpnewchar ;break;
                case "3": tmpnewchar="叁" + tmpnewchar ;break;
                case "4": tmpnewchar="肆" + tmpnewchar ;break;
                case "5": tmpnewchar="伍" + tmpnewchar ;break;
                case "6": tmpnewchar="陆" + tmpnewchar ;break;
                case "7": tmpnewchar="柒" + tmpnewchar ;break;
                case "8": tmpnewchar="捌" + tmpnewchar ;break;
                case "9": tmpnewchar="玖" + tmpnewchar ;break;
                }
                switch(part[0].length-i-1){
                case 0: tmpnewchar = tmpnewchar +"元" ;break;
                case 1: if(perchar!=0)tmpnewchar= tmpnewchar +"拾" ;break;
                case 2: if(perchar!=0)tmpnewchar= tmpnewchar +"佰" ;break;
                case 3: if(perchar!=0)tmpnewchar= tmpnewchar +"仟" ;break;
                case 4: tmpnewchar= tmpnewchar +"万" ;break;
                case 5: if(perchar!=0)tmpnewchar= tmpnewchar +"拾" ;break;
                case 6: if(perchar!=0)tmpnewchar= tmpnewchar +"佰" ;break;
                case 7: if(perchar!=0)tmpnewchar= tmpnewchar +"仟" ;break;
                case 8: tmpnewchar= tmpnewchar +"亿" ;break;
                case 9: tmpnewchar= tmpnewchar +"拾" ;break;
                }
                newchar = tmpnewchar + newchar;
            }
            //小数点之后进行转化
            if(Num.indexOf(".")!=-1){
            if(part[1].length > 2) {
                setBottomStatusInfo("小数点之后只能保留两位,系统将自动截段","提醒");
                part[1] = part[1].substr(0,2);
                }
            for(i=0;i<part[1].length;i++){
                    var tmpnewchar = "";
                    var perchar = part[1].charAt(i);
                    switch(perchar){
                    case "0": tmpnewchar="零" + tmpnewchar ;break;
                    case "1": tmpnewchar="壹" + tmpnewchar ;break;
                    case "2": tmpnewchar="贰" + tmpnewchar ;break;
                    case "3": tmpnewchar="叁" + tmpnewchar ;break;
                    case "4": tmpnewchar="肆" + tmpnewchar ;break;
                    case "5": tmpnewchar="伍" + tmpnewchar ;break;
                    case "6": tmpnewchar="陆" + tmpnewchar ;break;
                    case "7": tmpnewchar="柒" + tmpnewchar ;break;
                    case "8": tmpnewchar="捌" + tmpnewchar ;break;
                    case "9": tmpnewchar="玖" + tmpnewchar ;break;
                    }
                    if(i==0)tmpnewchar =tmpnewchar + "角";
                    if(i==1)tmpnewchar = tmpnewchar + "分";
                    newchar = newchar + tmpnewchar;
            }
            }
            //替换所有无用汉字
            while(newchar.search("零零") != -1){
                newchar = newchar.replace("零零", "零");
            }
            newchar = newchar.replace("零亿", "亿");
            newchar = newchar.replace("零万", "万");
            newchar = newchar.replace("亿万", "亿");
            newchar = newchar.replace("零角", "");
            newchar = newchar.replace("零分", "");

            if (newchar.charAt(newchar.length-1) == "元" || newchar.charAt(newchar.length-1) == "角"){
                newchar = newchar+"整";
            }
            return newchar;
        }

        //设置token信息（解决前端跨域cookie丢失问题）
        Vue.prototype.initToken = function() {
            var q_fftoken = this.$route.query.ffToken
            var c_fftoken = axios.getCookie("ffToken")
            if ((c_fftoken == undefined || c_fftoken == null || c_fftoken == '')
                && q_fftoken != undefined && q_fftoken != null && q_fftoken != ''){
                // 如果从请求中获取不到ffToken，则从参数中获取
                axios.Setcookie("ffToken", q_fftoken)
            }
        }

        /**
         * 格式化消息
         * @param {*} source
         * @param {*} params
         * @returns
         */
        Vue.prototype.formatMessage = function (source, params) {
            if (!params) {
                return '';
            }

            if (params.constructor !== Array) {
                params = [params];
            }

            for (let i = 0; i < params.length; i++) {
                source = source.replace(new RegExp("\\{" + i + "\\}", "g"), params[i])
            }

            return source;
        }

        Vue.prototype.sliceStr = function (params,start,end) {
            if (!params) {
                return '';
            }
            let temp = '';
            if(params.length > end){
              temp = params.slice(start,end);
              temp += '...';
            }else{
              temp = params;
            }

            return temp;
        }

        Vue.prototype.getObjectValue = function (obj,prop) {
            let temp = '';
            if (typeof(obj) != "undefined"){
              temp = obj[prop];
            }

            return temp;
        }

        // 获取系统前端上下文路径
        Vue.prototype.getContextPath = function (sysid) {
            var sContextPath = "";
            if (sysid == "CONTRACT") {
                sContextPath = process.env.SYS_PRE_CONTRACT;
            } else if (sysid == "HR") {
                sContextPath = process.env.SYS_PRE_HR;
            } else if (sysid == "SCM") {
                sContextPath = process.env.SYS_PRE_SCM;
            } else if (sysid == "PROJECT") {
                sContextPath = process.env.SYS_PRE_PROJECT;
            }

            if (this.isNotNullOrEmpty(sContextPath)) {
                let endIndex = sContextPath.lastIndexOf("/");
                if (endIndex !== -1) {
                    sContextPath = sContextPath.substring(0, endIndex);
                }
            }

            return sContextPath;
        }
        
        /**
         * 千分位格式化
         */
        Vue.prototype.commaFy= function (number){
            if (this.isNotNullOrEmpty(number)){
                return parseFloat(number).toLocaleString()
            }else{
                return null
            }
        }

        // 构造当前页校验表单
        Vue.prototype.buildCurrPageForms = function () {
            let aForm = [];
            let sMainFormName = this.validFormInfo.mainFormName;
            if (sMainFormName) {
                aForm.push(
                    new Promise((resolve, reject) => {
                        this.$refs[sMainFormName].validate(valid => {
                            if (valid) {
                                resolve();
                            } else {
                                reject();
                            }
                        });
                    })
                );
            }

            let aChildComponentName = this.validFormInfo.childComponentName;
            if (aChildComponentName) {
                for (let currChildComponentName of aChildComponentName) {
                    if (!currChildComponentName) {
                        continue;
                    }
                    aForm.push(
                        new Promise((resolve, reject) => {
                            this.$refs[currChildComponentName].$refs[
                                "ruleForm"
                            ].validate(valid => {
                                if (valid) {
                                    resolve();
                                } else {
                                    reject();
                                }
                            });
                        })
                    );
                }
            }

            return aForm;
        }

        /**
        * 遍历列的所有内容，获取最宽一列的宽度
        * @param arr
        */
        Vue.prototype.getMaxLength= function (arr){
            return arr.reduce((acc, item) => {
                if (item) {
                  let calcLen = this.getTextWidth(item)
                  if (acc < calcLen) {
                    acc = calcLen
                  }
                }
                return acc
              }, 0)
        }

        /**
        * 遍历列的所有内容，获取最宽一列的宽度
        * @param arr
        */
       Vue.prototype.getTextWidth= function (str){
            let width = 0;
            let html = document.createElement('span');
            html.innerText = str;
            html.className = 'getTextWidth';
            document.querySelector('body').appendChild(html);
            width = document.querySelector('.getTextWidth').offsetWidth;
            document.querySelector('.getTextWidth').remove();
            return width;
        }

        /**
        * 递归方式实现对象深拷贝
        * @param arr
        */
       Vue.prototype.deepCopy= function (obj) { 
            var newobj = obj.constructor === Array ? [] : {};
            if (typeof obj !== 'object') {
                return obj;
            } else {
                for (var i in obj) {
                    if (typeof obj[i] === 'object'){ //判断对象的这条属性是否为对象
                        newobj[i] = this.deepCopy(obj[i]);  //若是对象进行嵌套调用
                    }else{
                        newobj[i] = obj[i];
                    }
                }
            }
            return newobj; //返回深度克隆后的对象
        }

        let Num = Number
        Num.prototype.toFixed = function (d) {
            let s = this + ''
            if (!d) d = 0
            if (s.indexOf('.') === -1) s += '.'
            s += new Array(d + 1).join('0')
            if (new RegExp('^(-|\\+)?(\\d+(\\.\\d{0,' + (d + 1) + '})?)\\d*$').test(s)) {
            let ss = '0' + RegExp.$2
            let pm = RegExp.$1
            let a = RegExp.$3.length
            let b = true
                if (a === d + 2) {
                    a = ss.match(/\d/g)
                    if (parseInt(a[a.length - 1]) > 4) {
                        for (let i = a.length - 2; i >= 0; i--) {
                            a[i] = parseInt(a[i]) + 1
                            if (a[i] === 10) {
                                a[i] = 0
                                b = i !== 1
                            } else break
                        }
                    }
                    ss = a.join('').replace(new RegExp('(\\d+)(\\d{' + d + '})\\d$'), '$1.$2')
                }
                if (b) ss = ss.substr(1)
                return (pm + ss).replace(/\.$/, '')
            }
            return this + ''
        }
    }
}



// WEBPACK FOOTER //
// ./src/js/common.js